import i18n from '@i18next/i18n';
import React from 'react';
import Style from './index.less';
import arrowRightSvg from '@tencent/docs-design-resources/mobile/svg/icon_thirdary_arrow_right.svg';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

interface INoteAreaWrapperProps {
    title: string;
    imageUrl: string;
    description: string;
    vendorName: string;
    vendorSite: string;
}

function IntelligentToolDescriptionCard(props: INoteAreaWrapperProps) {
    const { title, vendorSite, vendorName, imageUrl, description } = props;

    const onClick = () => {
        const options = {
            url: vendorSite,
            replace: false,
            windowName: '_blank',
        };
        openUrlForAll(options);
    };

    return (
        <div className={Style.container}>
            <div className={Style.title}>{title}</div>
            <div className={Style['link-container']} onClick={onClick}>
                <div className={Style['vendor-link']}>{`${i18n.t('来自')}：${vendorName}`}</div>
                <img src={arrowRightSvg} style={{ display: 'inline-block', alignItems: 'center' }} />
            </div>
            <img className={Style['main-image']} src={imageUrl} />
            <div className={Style.description}>{description}</div>
        </div>
    );
}

export default IntelligentToolDescriptionCard;
